import angular from 'angular';
import {
  pmSharedModelService
} from 'app/services';
import {
  actionIcon,
} from 'app/components/global';
import SyncableSectionTitleChangeDirective from './syncable-section-title-change.directive';
import SyncableSectionTitleChangeController from './syncable-section-title-change.controller';
import SyncableSectionBodyChangeDirective from './syncable-section-body-change.directive';
import SyncableSectionBodyChangeController from './syncable-section-body-change.controller';
import SyncableEndnoteChangeDirective from './syncable-endnote-change.directive';
import SyncableEndnoteChangeController from './syncable-endnote-change.controller';

export default angular.module('app.components.advisory.policyManagement.syncOutstandingRecommended', [
  actionIcon,
  pmSharedModelService,
])
  .directive('syncableSectionTitleChange', SyncableSectionTitleChangeDirective)
  .controller('SyncableSectionTitleChangeController', SyncableSectionTitleChangeController)
  .directive('syncableSectionBodyChange', SyncableSectionBodyChangeDirective)
  .controller('SyncableSectionBodyChangeController', SyncableSectionBodyChangeController)
  .directive('syncableEndnoteChange', SyncableEndnoteChangeDirective)
  .controller('SyncableEndnoteChangeController', SyncableEndnoteChangeController)
  .name;

console.log('app.components.advisory.policyManagement.syncOutstandingRecommended');
